import { thirdPartyConnectedDataSourceResource } from '@jira/router-resources__third-party-connected-data-source/src/index.tsx';
import { getIssueCircuitBreaker } from '@jira/router-routes-issue-circuit-breaker/src/index.tsx';
import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/entrypoint.tsx';
import { IssueViewSkeleton } from '@jira/issue__issue-view-skeleton/src/IssueViewSkeleton.tsx';
import { currentUserResource } from '@jira/router-resources__current-user/src/index.tsx';
import { nav4SidebarContentCoreEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-core/entrypoint.tsx';
import { nav4ProjectsContentEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-core/src/ui/projects/default/async-content/entrypoint.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { ISSUE_VIEW } from '@atlassian/jira-capabilities/src/constants.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { genericProjectLayout } from '@atlassian/jira-generic-project-layout/src/index.tsx';
import { fullPageIssuePreloadLayout } from '@atlassian/jira-issue-preload-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV } from '@atlassian/jira-navigation-apps-horizontal-nav-selector/src/constants.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { genericProjectSidebars } from '@atlassian/jira-navigation-apps-sidebar-generic-sidebars/src/ui/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { issueViewRelayResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-agg-data/index.tsx';
import { issueGiraDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-gira-data/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { getOfferingCatalogueFeaturesResource } from '@atlassian/jira-router-resources-offering-catalogue-features/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { queuesNavigationItems as servicedeskNavigationItemsResource } from '@atlassian/jira-router-resources-service-desk-queues/src/services/index.tsx';
import { jsmProjectMenuContentSidebarResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/jsm-customize-sidebar/index.tsx';
import { browseIssueRoute } from '@atlassian/jira-router-routes-issue-routes/src/browseIssueRoute.tsx';
import { workspaceResource } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/index.tsx';
import { getAIContextPanelResources } from '@atlassian/jira-servicedesk-ai-context-panel-resources/src/services/index.tsx';
import { getDraftReplyPillsResource } from '@atlassian/jira-servicedesk-draft-reply-resources/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { projectGlobalComponentsResource } from '@atlassian/jira-router-resources-project-global-components/src/services/index.tsx';
import {
	getJsmIssueViewRelatedArticlesResource,
	getJsmIssueViewSlaPanelResource,
} from '@atlassian/jira-router-resources-jsm-issue-view/src/services/index.tsx';
import { postOfficeJiraIssueViewTwcSpotlightTourResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';

import { nav4JSWProjectEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu/src/ui/jsw-expandable-project/async-content/entrypoint.tsx';

import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { issueViewEntryPoint } from '@atlassian/jira-spa-apps-issue/entrypoint.tsx';

import { issueCollapsibleGroupDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-collapsible-group-data/issue-collapsible-group-data-resource.tsx';
import { issueHideEmptyFieldsDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-hide-empty-fields-data/issue-hide-empty-fields-data-resource.tsx';
import { issueViewRemoteDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-view-remote-data/index.tsx';
import { issueSelectedTabDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-selected-tab-data/issue-selected-tab-data-resource.tsx';
import { IssueComponent, LazyIssuePage } from './ui/index.tsx';

const resourcesOld = () => [
	...getNavigationResources({
		isUsingSidebarEntrypoint: fg('move-issue-view-to-entrypoint'),
	}),
	// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
	projectContextResource,
	staticSidebarShortcutsResource,
	staticProjectSidebarNavigationResource,
	// end of resources expanded from getNavigationSidebarProjectResource
	...getOfferingCatalogueFeaturesResource(),
	issueGiraDataResource,
	issueViewRelayResource,
	servicedeskNavigationItemsResource,
	workspaceResource,
	getConsolidationStateResource(),
	...getAIContextPanelResources(),
	...getDraftReplyPillsResource(),
	resourceWithCondition2(
		() => fg('jira-project-isglobalcomponent-route-resource'),
		projectGlobalComponentsResource,
	),
	resourceWithCondition2(
		() => fg('jira-issue-view-twc-spotlight-tour-ssr'),
		postOfficeJiraIssueViewTwcSpotlightTourResource,
	),
	resourceWithCondition2(
		() => fg('support-getting-customization-using-issue-key'),
		jsmProjectMenuContentSidebarResource,
	),
	resourceWithCondition2(
		() => fg('jiv-21223_issue_view_remote_data_query_earlier'),
		issueViewRemoteDataResource,
	),
];

// jfp-magma-3491-reorder-issue-view-route-resources - These resources have been re-ordered. We have a theory that moving the more expensive ones to be first in the list makes them faster in SSR, there some small overhead that compounds over the 30 odd requests that happens.
// Longest poles at the moment are issueViewRelayResource and issueGiraDataResource, so we have moved them to the top of the list.
const resourcesNew = () => [
	issueViewRelayResource,
	issueGiraDataResource,
	// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
	...getNavigationResources({
		isUsingSidebarEntrypoint: fg('move-issue-view-to-entrypoint'),
	}),
	projectContextResource,
	staticSidebarShortcutsResource,
	// end of resources expanded from getNavigationSidebarProjectResource
	staticProjectSidebarNavigationResource,
	...getOfferingCatalogueFeaturesResource(),
	servicedeskNavigationItemsResource,
	workspaceResource,
	getConsolidationStateResource(),
	...getAIContextPanelResources(),
	...getDraftReplyPillsResource(),
	resourceWithCondition2(
		() => fg('jira-project-isglobalcomponent-route-resource'),
		projectGlobalComponentsResource,
	),
	resourceWithCondition2(
		() => fg('magma-3869-jsm-issue-view-sla-panel-fixes'),
		getJsmIssueViewSlaPanelResource(),
	),
	resourceWithCondition2(
		() => fg('clefairy-12-move-knowledge-base-to-ssr'),
		getJsmIssueViewRelatedArticlesResource(),
	),
	resourceWithCondition2(
		() => fg('jfp-magma-ssr-issue-selected-tab'),
		issueSelectedTabDataResource,
	),
	resourceWithCondition2(
		() => fg('jfp-magma-ssr-iv-collapse-group'),
		issueCollapsibleGroupDataResource,
	),
	resourceWithCondition2(
		() => fg('ken-3458-jira-hide-empty-field-ssr-fix'),
		issueHideEmptyFieldsDataResource,
	),
	resourceWithCondition2(
		() => fg('jira-issue-view-twc-spotlight-tour-ssr'),
		postOfficeJiraIssueViewTwcSpotlightTourResource,
	),
	resourceWithCondition2(
		() => fg('support-getting-customization-using-issue-key'),
		jsmProjectMenuContentSidebarResource,
	),
	resourceWithCondition2(
		() => fg('jiv-21223_issue_view_remote_data_query_earlier'),
		issueViewRemoteDataResource,
	),
	resourceWithCondition2(
		() => fg('jira-issue-view-3p-attachments'), // additional FG that need 3P resources should use or condition
		thirdPartyConnectedDataSourceResource,
	),
	resourceWithCondition2(() => fg('jfp-magma-current-user-resource'), currentUserResource),
];

const entrypoint = createPageEntryPoint({
	main: issueViewEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: {
			projects: {
				entryPoint: nav4ProjectsContentEntryPoint,
			},
			boards: {
				entryPoint: nav4JSWProjectEntryPoint,
			},
		},
		isProjectsExpanded: true,
	},
	redirect: userSegRedirectEntrypoint,
});

export const browseIssueRouteEntry = createEntry(browseIssueRoute, () => ({
	isStrictModeEnabled: false,
	group: 'issue',
	isHydrateRootEnabled: fg('jfp-magma-issue-view-full-page-hydrate-root'),
	preloadOptions: {
		earlyChunks: ['issue-app-early-entry'],
	},
	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	component: fg('move-issue-view-to-entrypoint') ? undefined : IssueComponent,
	skeleton: IssueViewSkeleton,
	layout: composeLayouts(genericProjectLayout, fullPageIssuePreloadLayout),
	navigation: {
		sidebar: genericProjectSidebars,
		menuId: MENU_ID.PROJECTS,
		sidebarId: fg('move-issue-view-to-entrypoint') ? SIDEBAR_ID.CONTENT : undefined,
		horizontal: GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV,
	},
	resources: fg('jfp-magma-3491-reorder-issue-view-route-resources')
		? resourcesNew()
		: resourcesOld(),
	forPaint: [LazyAtlassianNavigation, LazyIssuePage],
	ufoName: 'issue-view',
	meta: {
		capability: ISSUE_VIEW,
	},
	bifrost: {
		bifrostGroup: 'issue-view',
		bundling: {
			packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueRouteEntry.tsx',
			whichExportToUse: 'browseIssueRouteEntry',
		},
		enabled: true,
		manifestName: 'jira-spa-issue-view.json',
		circuitBreakerConfig: getIssueCircuitBreaker(),
	},

	supportsPreviewPanel: true,
	entryPoint: fg('move-issue-view-to-entrypoint') ? () => entrypoint : undefined,
	entryPointOptions: fg('jfp-magma-concurrent-entrypoint-router-metric-fix')
		? { isSSRPlaceholderEnabled: true }
		: undefined,
}));
